// src/Home.js
import React from 'react';
import './styles.css';

const Example = () => {
  return (
    <div className="relative min-h-screen bg-black flex items-center justify-center">
      <div className="starfield">
        <div className="stars"></div>
        <div className="stars"></div>
        <div className="stars"></div>
        <div className="stars"></div>
        <div className="stars"></div>
      </div>
     
    </div>
  );
}

export default Example;

